/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --color: var(--nve-sys-text-muted-color);
  --width: var(--nve-ref-size-400);
  --height: var(--nve-ref-size-400);
  display: inline-flex;
  contain: layout;
}

[internal-host] {
  --_width: calc(var(--width) * var(--nve-ref-scale-size, 1));
  --_height: calc(var(--height) * var(--nve-ref-scale-size, 1));
  color: var(--color);
  width: var(--width);
  height: var(--height);
  display: flex;
  justify-content: center;
  align-items: center;
}

svg {
  width: var(--_width);
  height: var(--_height);
}

:host([outline]) {
  outline: 1px dashed var(--color);
}

:host([size='xs']) {
  --width: var(--nve-ref-size-200);
  --height: var(--nve-ref-size-200);
}

:host([size='sm']) {
  --width: var(--nve-ref-size-300);
  --height: var(--nve-ref-size-300);
}

:host([size='lg']) {
  --width: var(--nve-ref-size-500);
  --height: var(--nve-ref-size-500);
}

:host([size='xl']) {
  --width: var(--nve-ref-size-600);
  --height: var(--nve-ref-size-600);
}

/* optical spacing */
:host([name='arrow']),
:host([name='arrow-angle']),
:host([name='cancel']),
:host([name='caret']),
:host([name='chevron']),
:host([name='double-chevron']) {
  --nve-ref-scale-size: 0.8;
}

:host([direction='up']) {
  transform: rotate(0deg);
}

:host([direction='down']) {
  transform: rotate(180deg);
}

:host([direction='left']) {
  transform: rotate(270deg);
}

:host([direction='right']) {
  transform: rotate(90deg);
}

:host([status='success']) {
  --color: var(--nve-sys-support-success-color);
}

:host([status='warning']) {
  --color: var(--nve-sys-support-warning-color);
}

:host([status='danger']) {
  --color: var(--nve-sys-support-danger-color);
}

:host([status='accent']) {
  --color: var(--nve-sys-support-accent-color);
}
